import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-833981d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "name text-truncate" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "#", -1))
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "leaderboard-menu" }

import {computed, onMounted, ref} from "vue";
import config from "@/config.json";
import {useRoute} from "vue-router";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderboardView',
  setup(__props) {

const route = useRoute()
let guildName = ref(i18n.global.t('Leaderboard.loading'))
let pageCount = ref(0)
let leaders = ref([])
let sortBy = ref('balance')
let sort = ref('balance')
const sortItems = computed(() => [
  {title: i18n.global.t('Leaderboard.balance'), value: 'balance'},
  {title: i18n.global.t('Leaderboard.xp'), value: 'xp'}
])
let page = ref(1)
let loading = ref(true)
let width = ref(window.innerWidth)

window.addEventListener('resize', () => width.value = window.innerWidth)

async function loadLeaderboard() {
  loading.value = true;
  let response = await fetch(`${config.API}/private/leaderboard/` +
      `${route.params.id}?page=${page.value}&sort=${sortBy.value}`, {
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  let body = await response.json();
  if (!response.ok) return window.location.replace('/@me');
  guildName.value = body.guildName;
  pageCount.value = body.pageCount;
  leaders.value = body.leaders;
  loading.value = false;
  sort.value = sortBy.value;
}

onMounted(async () => {
  await loadLeaderboard()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(guildName)), 1),
    _createVNode(_component_v_table, { class: "leaderboard-table item-center" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('Leaderboard.user')), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t(`Leaderboard.${_unref(sortBy)}`)), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leaders), (leader) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(leader.number), 1),
              _createElementVNode("td", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "user-link",
                  to: `/leaderboard/${_ctx.$route.params.id}/${leader.user.id}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: leader.user.avatar,
                      class: "user-avatar",
                      alt: ""
                    }, null, 8, _hoisted_8),
                    _createElementVNode("span", null, _toDisplayString(leader.user.username), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, _toDisplayString(Number(leader[_unref(sort)]).toLocaleString(_ctx.$i18n.locale)), 1)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          class: "loading item-center",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createVNode(_component_v_pagination, {
          modelValue: _unref(page),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
            loadLeaderboard
          ],
          length: _unref(pageCount),
          disabled: _unref(loading),
          "total-visible": _unref(width) >= 600 ? 7 : 0
        }, null, 8, ["modelValue", "length", "disabled", "total-visible"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_select, {
          modelValue: _unref(sortBy),
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (_isRef(sortBy) ? (sortBy).value = $event : sortBy = $event)),
            loadLeaderboard
          ],
          class: "sort-select",
          items: sortItems.value,
          disabled: _unref(loading),
          label: _ctx.$t('Leaderboard.sort')
        }, null, 8, ["modelValue", "items", "disabled", "label"])
      ])
    ])
  ]))
}
}

})